import { Button as MuiButton, styled } from '@mui/material';
import { pxToRem } from '@themes';
var StyledButton = styled(MuiButton)(function (_ref) {
  var size = _ref.size;
  var styles = {
    padding: "".concat(pxToRem(14), " ").concat(pxToRem(20)),
    borderRadius: pxToRem(16),
    textTransform: 'none',
    fontWeight: 500
  };

  switch (size) {
    case 'small':
      {
        styles.padding = "".concat(pxToRem(8), " ").concat(pxToRem(16));
        styles.fontSize = pxToRem(14);
        break;
      }
  }

  return styles;
});
export { StyledButton };